import { render, staticRenderFns } from "./statistics-recruitment-workexperience.vue?vue&type=template&id=f9e56ad2"
import script from "./statistics-recruitment-workexperience.vue?vue&type=script&lang=js"
export * from "./statistics-recruitment-workexperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports